import React from 'react';

export function ProjectEquipmentValueDistribution() {
  const distribution = [
    { label: 'Đang sử dụng', value: '4.450.000.000', percent: 58, color: 'bg-emerald-500' },
    { label: 'Bảo dưỡng định kỳ', value: '1.100.000.000', percent: 13, color: 'bg-amber-500' },
    { name: 'Đang sử dụng', value: '4.450.000.000', percent: 58, color: 'bg-emerald-500' },
    { name: 'Bảo dưỡng định kỳ', value: '1.100.000.000', percent: 13, color: 'bg-amber-500' },
    { name: 'Đang sửa chữa', value: '350.000.000', percent: 6, color: 'bg-rose-500' },
    { name: 'Chờ sử dụng', value: '1.950.000.000', percent: 23, color: 'bg-slate-300' },
  ];

  return (
    <div className="bg-white rounded-md border border-slate-100 p-4  space-y-4">
      <div className="flex items-center justify-between border-b border-slate-50 pb-2">
        <h3 className="text-sm font-normal text-slate-900">Phân bổ giá trị theo loại</h3>
        <button className="text-xs font-normal text-emerald-600 hover:underline">Chi tiết</button>
      </div>
      
      <div className="space-y-4">
        {distribution.map((item, idx) => (
          <div key={idx} className="space-y-1.5">
            <div className="flex justify-between text-xs font-normal mb-1">
               <span className="text-slate-600">{item.name}</span>
               <span className="text-slate-900">{item.value} ({item.percent}%)</span>
            </div>
            <div className="h-1.5 rounded-full bg-slate-50 overflow-hidden">
               <div className={`${item.color} h-full transition-all duration-700`} style={{ width: `${item.percent}%` }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
